import { createContext, ReactNode, useContext } from 'react';

export type StockBalancesFiltersContextValue = {
  regionOptions: { label: string; value: string }[];
  categoryOptions: { label: string; value: string }[];
  filterRevision: number;
};

const StockBalancesFiltersContext = createContext<StockBalancesFiltersContextValue | null>(null);

type TProviderProps = {
  value: StockBalancesFiltersContextValue;
  children: ReactNode;
};

export const StockBalancesFiltersProvider = ({ value, children }: TProviderProps) => (
  <StockBalancesFiltersContext.Provider value={value}>{children}</StockBalancesFiltersContext.Provider>
);

export const useStockBalancesFiltersContext = () => {
  const context = useContext(StockBalancesFiltersContext);

  if (!context) {
    throw new Error('useStockBalancesFiltersContext must be used within StockBalancesFiltersProvider');
  }

  return context;
};
